export default __webpack_public_path__ + "static/media/104.2594fef3.jpg";